import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageReferralComponent } from './manage-referral.component';


const routes: Routes = [
    {
        path: '',
        component: ManageReferralComponent,
        data: {
            title: 'Manage Referrals'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManageReferralRoutingModule { }
